import { DateTime, Settings } from 'luxon'
import i18next from 'i18next'

Settings.defaultLocale = i18next.language || 'en'

export const dt = DateTime

i18next.on('languageChanged', (lang) => {
  Settings.defaultLocale = lang
})
